//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('labourSalaryType', {
//        templateUrl: 'views/components/views/labourSalaryType/labourSalaryType.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'labourSalaryTypeService', function ($stateParams, stateService, labourSalaryTypeService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let labourSalaryTypeKeyno = $stateParams.laboursalarytype_keyno;
            
//            vm.model = {
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadEdit() {
//                vm.model.edit = (await labourSalaryTypeService.getEdit({ laboursalarytype_keyno: labourSalaryTypeKeyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region BUTTON SAVE FUNCTION

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                labourSalaryTypeService.saveObj(vm.model.edit).then(function () {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, function () {
//                    vm.model.lockedSave = false;
//                });
//            }

//            // #endregion BUTTON SAVE FUNCTION

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
